import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import HearingaidoffersWrapper from "@components/layouts/hearingAidOffersWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function HearingAidOffersHome(): ReactElement {
    return (
        <HearingaidoffersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Hearing Aid Offers"
                    domain="HearingAidOffers.com"
                />
            </div>
        </HearingaidoffersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
